<template>
  <div>
    <div class="content">
      <es-form>
        <template #es-form>
          <table class="is-full-width">
            <thead>
              <tr>
                <th class="column-left"></th>
                <th>Start Date</th>
                <th>End Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(mapping, index) in mappings"
                :key="index">
                <td v-if="mapping.code !== ''" >
                  <div class="badge badge-secondary">
                    <span class="tag">{{mapping.description}}</span>
                  </div>
                </td>
                <td v-else >
                  <div v-if="editmode && toggle" class="select display-block"
                    :class="{ 'is-danger' : hasErrorCodeLocal }">
                      <select class="input is-full-width" v-model="mapping.code"
                        @change.prevent="checkNewMapping('code', mapping)">
                        <option value>Add a new {{maptype}}</option>
                        <option
                          v-for="(item, index) in available"
                          :key="index"
                          :value="item.code">
                          {{ item.description }}
                        </option>
                      </select>
                      <p v-if="hasErrorCodeLocal"
                        class="help is-danger">
                      {{ maptype }} is required
                      </p>
                  </div>
                </td>
                <td>
                  <div
                    v-if="!editmode">
                    {{ mapping.startDateYYYYMMDD | formatDateMMDDYYYY }}
                  </div>
                  <div class="field" v-if="editmode && toggle">
                    <div class="control">
                      <input
                        type="date"
                        class="input calendar"
                        :class="{ 'is-danger' : mapping.hasErrorStartDate }"
                        v-model="mapping.startDateYYYYMMDD"
                        @change.prevent="checkDateFormat('startDate',mapping)"/>
                      <p v-if="mapping.hasErrorStartDate"
                        class="help is-danger">
                      {{ mapping.msgStartDate }}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    v-if="!editmode">
                    {{ mapping.endDateYYYYMMDD | formatDateMMDDYYYY }}
                  </div>
                  <div class="field" v-if="editmode && toggle">
                    <div class="control">
                      <input
                        type="date"
                        class="input calendar"
                        :class="{ 'is-danger' : mapping.hasErrorEndDate }"
                        v-model="mapping.endDateYYYYMMDD"
                        @change.prevent="checkDateFormat('endDate',mapping)"/>
                      <p v-if="mapping.hasErrorEndDate"
                        class="help is-danger">
                        {{ mapping.msgEndDate }}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <div v-if="mapping.new">
                    <a @click.prevent="deleteNewRow(index)">
                      <font-awesome-icon :icon="['fal', 'times']" size="lg" />
                    </a>
                  </div>
                </td>
              </tr>
              <tr v-if="editmode && available !== undefined && available.length > 0">
                <td colspan="3">
                  <a @click.prevent="addNewRow()">+ Add A New {{maptype}}</a>
                </td>
              </tr>
            </tbody>
            <tbody v-if="!editmode && !mappings.length">
              <tr>
                <td colspan="7" class="has-text-centered">
                  <div class="no-result-container">
                    <div class="icon">
                      <font-awesome-icon :icon="['fal', 'exclamation-triangle']" size="3x"/>
                    </div>
                    <p></p>
                    <h5>No results were found.</h5>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </es-form>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import EsForm from '@/components/EsForm.vue';
import DateUtils from '@/mixins/DateUtils';

library.add(faTimes);

export default {
  mixins: [DateUtils],
  components: {
    EsForm,
  },
  props: ['mappings', 'lookups', 'editmode', 'maptype', 'hasErrorCode'],
  data() {
    return {
      newmapping: null,
      toggle: true,
    };
  },
  watch: {
    editmode(value) {
      if (value === false) {
        this.newmapping = null;
      }
    },
  },
  computed: {
    available() {
      const existing = this.mappings.map(g => g.code);
      return this.lookups.filter(item => !existing.includes(item.code));
    },
    hasErrorCodeLocal: {
      get() {
        return this.hasErrorCode;
      },
      set(d) {
        this.$emit('setHasErrorCode', d);
      },
    },
  },
  methods: {
    setRowSelection() {
      this.mappings.push({
        code: '',
        description: '',
        startDate: this.newmapping.startDateYYYYMMDD,
        startDateYYYYMMDD: this.newmapping.startDateYYYYMMDD,
        endDate: this.newmapping.endDateYYYYMMDD
          ? this.newmapping.endDateYYYYMMDD : '',
        endDateYYYYMMDD: this.newmapping.endDateYYYYMMDD,
        new: true,
      });
    },
    addNewRow() {
      if (this.mappings.some(m => m.code === '')) return;
      this.createNewMapping();
      this.setRowSelection();
    },
    createNewMapping() {
      this.newmapping = {
        code: '',
        startDate: new Date().toISOString().slice(0, 10),
        endDate: '',
        hasErrorStartDate: false,
        hasErrorEndDate: false,
        msgStartDate: '',
        msgEndDate: '',
      };
      this.newmapping.startDateYYYYMMDD = moment(this.newmapping.startDate).format('YYYY-MM-DD');
      if (this.newmapping.endDate !== undefined && this.newmapping.endDate !== '') {
        this.newmapping.endDateYYYYMMDD = moment(this.newmapping.endDate).format('YYYY-MM-DD');
      } else {
        this.newmapping.endDateYYYYMMDD = '';
      }
    },
    deleteNewRow(index) {
      this.mappings.splice(index, 1);
    },
    checkNewMapping(field, mapping) {
      const lg = mapping;
      if (field === 'code') {
        const lookup = this.lookups.find(l => l.code === lg.code);
        lg.description = lookup.description;
        this.hasErrorCodeLocal = false;
      }
    },
    checkDateFormat(field, mapping) {
      this.toggle = false;
      const lg = mapping;
      if (field === 'startDate') {
        if (lg.startDateYYYYMMDD === '') {
          lg.hasErrorStartDate = true;
          lg.msgStartDate = 'Start Date is required.';
        } else if (!this.isValidDateFormat(lg.startDateYYYYMMDD, 'YYYY-MM-DD')) {
          lg.hasErrorStartDate = true;
          lg.msgStartDate = 'Start Date is invalid.';
        } else {
          const startDate = this.getCorrectDateFromYYYYMMDDString(lg.startDateYYYYMMDD).getTime();
          const today = new Date().getTime();
          if (moment(startDate).isAfter(today)) {
            lg.hasErrorStartDate = true;
            lg.msgStartDate = 'Start Date cannot be future date.';
          } else {
            lg.hasErrorStartDate = false;
            lg.msgStartDate = '';
          }
        }
      }
      if (field === 'endDate') {
        if (lg.endDateYYYYMMDD === '') {
          lg.hasErrorEndDate = false;
          lg.msgEndDate = '';
        } else if (!this.isValidDateFormat(lg.endDateYYYYMMDD, 'YYYY-MM-DD')) {
          lg.hasErrorEndDate = true;
          lg.msgEndDate = 'End Date is invalid.';
        } else {
          const startDate = this.getCorrectDateFromYYYYMMDDString(lg.startDateYYYYMMDD).getTime();
          const endDate = this.getCorrectDateFromYYYYMMDDString(lg.endDateYYYYMMDD).getTime();
          const today = new Date().getTime();
          if (moment(startDate).isAfter(endDate)) {
            lg.hasErrorEndDate = true;
            lg.msgEndDate = 'End Date cannot be earlier than Start Date.';
          } else if (moment(endDate).isAfter(today)) {
            lg.hasErrorEndDate = true;
            lg.msgEndDate = 'End Date cannot be future date.';
          } else {
            lg.hasErrorEndDate = false;
            lg.msgEndDate = '';
          }
        }
      }
      this.toggle = true;
    },
  },
};
</script>

<style lang="sass" scoped>
  .column-left
    width: 50%
  .display-block
    display: block
  .no-result-container
    padding: 1.0rem
</style>
